import {observer} from 'mobx-react';
import * as React from 'react';
import {useContext, useEffect} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {useBreakpointContext} from '../../../../context-providers/BreakpointProvider';
import {getDataGridCommonProps} from '../helpers/data-grid-common-props';
import {getLockPendingWithdrawalsColumns, getLockPendingWithdrawalsColumnsMobile} from '../helpers/columns';
import './LockPendingWithdrawals.scss';
import NereusButton from "../../../NereusButton/NereusButton";
import {depositWithdrawalLockStore} from "../../../../services/deposit-withdrawal-lock/deposit-withdrawal-lock.store";
import {ServicesContext} from "../../../../context-providers/ServicesProvider";
import {useAccount} from "wagmi";
import {ContractContext} from "../../../../context-providers/ContractsProvider";
import {lockBalanceStore} from "../../../../stores/LockBalanceStore";


const PAGE_SIZE = 100;
const emptyStateText = 'No pending withdrawals';

const LockPendingWithdrawals = observer(() => {

    const { xs } = useBreakpointContext();
    const [paginationEnabled, setPaginationEnabled] = React.useState(depositWithdrawalLockStore.withdrawalsForRender.length > PAGE_SIZE);
    const { depositWithdrawLockService } = useContext(ServicesContext);
    const { address: userAddress } = useAccount();
    const { nrsLockWithdrawalTimelockContract, nrsContract, lockNrsContract } = useContext(ContractContext);

    useEffect(() => {
        setPaginationEnabled(depositWithdrawalLockStore.withdrawalsForRender.length > PAGE_SIZE);
    }, [depositWithdrawalLockStore.withdrawalsForRender.length]);

    const handleClaim = async (index: number) => {
        try {
            await depositWithdrawLockService.claim([index])
            if (userAddress) {
                lockBalanceStore.fetchBalances(nrsContract, lockNrsContract, userAddress)
                depositWithdrawalLockStore.fetchWithdrawals(nrsLockWithdrawalTimelockContract, userAddress)

            }
        } catch {}
    }
    const handleClaimAll = async () => {
        try {
            const claimableIndices = depositWithdrawalLockStore.claimableIndices
            await depositWithdrawLockService.claim(claimableIndices)
            if (userAddress) {
                lockBalanceStore.fetchBalances(nrsContract, lockNrsContract, userAddress)
                depositWithdrawalLockStore.fetchWithdrawals(nrsLockWithdrawalTimelockContract, userAddress)

            }
        } catch {}
    }

    return (
        <div className="LockPendingWithdrawals">
            <div className="LockPendingWithdrawals__header card-container text-white flex">
                <div className="LockPendingWithdrawals__header__balances flex flex-grow">
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">Requested Withdrawals</label>
                        <div className={`nereus-body-m`}>
                            {depositWithdrawalLockStore.requestedWithdrawalsAmountDecimal} NRS
                        </div>
                    </div>
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">Claimable Withdrawals</label>
                        <div className={`nereus-body-m`}>
                            {depositWithdrawalLockStore.claimableWithdrawalsAmountDecimal} NRS
                        </div>
                    </div>
                </div>
                {!xs && (
                    <div className="flex">
                        <div>
                            <NereusButton style={{width: 109}} variant="contained"
                                          onClick={() => {
                                              handleClaimAll()
                                          }}
                                          disabled={!depositWithdrawalLockStore.isClaimAvailable}
                                          className="bg-light-green text-dark-blue w-full">
                                Claim All
                            </NereusButton>
                        </div>
                    </div>
                )}
            </div>
            {xs && (
                <div className="nereus-background-color-bg2 pb-5 pl-5">
                    <NereusButton variant="contained"
                                  style={{minWidth: 129, width: 129}}
                                  onClick={() => {
                                      handleClaimAll()
                                  }}
                                  disabled={!depositWithdrawalLockStore.isClaimAvailable}
                                  className="bg-light-green text-dark-blue w-full">
                        Claim All
                    </NereusButton>
                </div>
            )}
            <div className="LockPendingWithdrawals__gridWrapper">
                {xs && <DataGrid
                    columnHeaderHeight={72}
                    rowHeight={72}
                    {...getDataGridCommonProps(emptyStateText)}
                    rows={depositWithdrawalLockStore.withdrawalsForRender}
                    columns={getLockPendingWithdrawalsColumnsMobile({handleClaim})}
                    hideFooter={!paginationEnabled}
                    initialState={{
                        pagination: {
                            paginationModel: {page: 0, pageSize: PAGE_SIZE}
                        },
                        sorting: {
                            sortModel: [{field: 'endTime', sort: 'asc'}]
                        }
                    }}
                />}
                {!xs && <DataGrid
                    {...getDataGridCommonProps(emptyStateText)}
                    rows={depositWithdrawalLockStore.withdrawalsForRender}
                    columns={getLockPendingWithdrawalsColumns({handleClaim})}
                    hideFooter={!paginationEnabled}
                    initialState={{
                        pagination: {
                            paginationModel: {page: 0, pageSize: PAGE_SIZE}
                        },
                        sorting: {
                            sortModel: [{field: 'endTime', sort: 'asc'}]
                        }
                    }}
                />}
            </div>
        </div>
    );
});

export default LockPendingWithdrawals;
